import React from 'react';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import Image from 'next/image';

import { useCountdownTimer } from 'modules/global';

dayjs.extend(duration);

const TestTime = ({ time, countdownMinutes }: { time?: number; countdownMinutes?: number; stopTimer?: boolean }) => {
  const { remaining } = useCountdownTimer(time, countdownMinutes);

  return (
    <div className="flex items-center gap-1 rounded-lg border-b border-b-indigo-300 bg-indigo-50 px-2 py-1 shadow-[inset_0px_2px_4px_0px_#CEB7DD61]">
      <div className='relative w-6 h-6'>
        <Image src="/images/test-clock-icon.webp" fill alt="Test clock" title="TESTNING vaqti" />
      </div>
      <span className="font-medium">{remaining || 0}</span>
    </div>
  );
};

export default TestTime;
